import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: "[content-container]"
})
export class ContentContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/content-container.directive.ts